"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dispenser = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const buttons_1 = require("../../../../../buttons");
const types_1 = require("../../../../../types");
const allowance_1 = require("./allowance");
const Dispenser = (props) => {
    const { service } = props;
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "dispenser"] }), (0, jsx_runtime_1.jsxs)(mui_page_layout_1.PageHeader, { message: "pages.dispenser.title", children: [service === types_1.ServiceType.ADMIN && (0, jsx_runtime_1.jsx)(allowance_1.DispenserAllowanceButton, {}), (0, jsx_runtime_1.jsx)(buttons_1.DispenserUploadButton, {})] }), (0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.dispenser.description" }) })] }));
};
exports.Dispenser = Dispenser;
//# sourceMappingURL=index.js.map